import { NavLink, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import './TabBar.css';

const IN_UNIVERSE_PATHS = ['/slugs', '/workspace', '/chat', '/universe-settings'];

const tabs = [
  { to: '/slugs', label: 'Slugs' },
  { to: '/workspace', label: 'Workspace' },
  { to: '/chat', label: 'Chat' },
];

export default function TabBar() {
  const location = useLocation();
  const inUniverse = IN_UNIVERSE_PATHS.some(
    (p) => location.pathname === p || location.pathname.startsWith(p + '/')
  );
  if (!inUniverse) return null;

  return (
    <nav className="tab-bar">
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          className={({ isActive }) => clsx('tab', isActive && 'active')}
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
